/**
 * Icon Colors
 * All icon-related colors used throughout the application
 */
import { palette, createColor } from './palette.colors';

// Eye icon colors (password visibility toggle)
export const eyeColors = {
  openIcon: createColor(palette.gray.black, palette.dark.textAlt),
  closeIcon: createColor(palette.gray.black, palette.dark.textAlt),
};

// Help/Info icon colors
export const helpColors = {
  text: createColor(palette.gray.darkest, palette.dark.textAlt),
  subText: createColor(palette.gray.darkest, palette.gray.darkest),
  border: createColor(palette.gray.border, palette.special.transparent),
  icon: createColor(palette.blue.onTint, palette.dark.text),
};

// Language selector icon colors
export const languageColors = {
  icon: createColor(palette.gray.black, palette.gray.white),
  selectedText: createColor(palette.blue.onTint, palette.dark.text),
};

// Dashboard menu icons
export const dashboardMenuColors = {
  iconColor: createColor(palette.gray.dark),
  selectedIconColor: createColor(palette.blue.primary),
};

// Help menu icons
export const helpMenuColors = {
  iconColor: createColor(palette.gray.darker),
  selectedIconColor: createColor(palette.gray.darker),
};

// Profile menu icons
export const profileMenuColors = {
  iconBG: createColor(palette.gray.light),
  BGColor: createColor(palette.blue.primary, palette.blue.primary),
  textColor: createColor(palette.gray.white, palette.gray.white),
};

// Notification menu icons
export const notificationMenuColors = {
  iconColor: createColor(palette.gray.darker),
  selectedIconColor: createColor(palette.gray.darker),
};

// Logout icon colors
export const logoutColors = {
  iconColor: createColor(palette.semantic.darkRed),
  textColor: createColor(palette.semantic.darkRed),
};

// All icon colors grouped together
export const iconColors = {
  eye: eyeColors,
  help: helpColors,
  language: languageColors,
  dashboardMenu: dashboardMenuColors,
  helpMenu: helpMenuColors,
  profile: profileMenuColors,
  notification: notificationMenuColors,
  logout: logoutColors,
};